"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Button_1 = __importDefault(require("../Button"));
const rebass_1 = require("rebass");
const Icon_1 = require("../Icon");
function default_1({ selectedIds, title, width = 400, visible, actions, children, scrollable = false, closeButtonVisible = false, backdropCloseEnalbed = true, onClose = () => { }, }) {
    const renderActions = (actions, isLeft = false) => {
        var _a;
        return (actions === null || actions === void 0 ? void 0 : actions.length) ? ((_a = actions === null || actions === void 0 ? void 0 : actions.filter((action) => !!action.left === isLeft)) === null || _a === void 0 ? void 0 : _a.map((action, idx) => (react_1.default.createElement(rebass_1.Box, { marginX: 1 },
            react_1.default.createElement(Button_1.default, { iconBefore: action.iconBefore, iconAfter: action.iconAfter, onClick: action.onClick, variant: action.variant, key: idx }, action.title))))) : (react_1.default.createElement(react_1.default.Fragment, null));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        visible && react_1.default.createElement(Backdrop, null),
        visible && (react_1.default.createElement(BackdropTransparent, { onClick: (e) => {
                backdropCloseEnalbed && onClose();
            }, padding: [0, 20] },
            react_1.default.createElement(rebass_1.Box, Object.assign({ margin: "auto" }, (scrollable
                ? {
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }
                : { display: "block" })),
                react_1.default.createElement(rebass_1.Flex, { flexDirection: "column" },
                    react_1.default.createElement(ModalWrap, { width: width, onClick: (e) => e.preventDefault() },
                        closeButtonVisible && (react_1.default.createElement(CloseButton, { onClick: onClose },
                            react_1.default.createElement(Icon_1.CloseIcon, { width: 30 }))),
                        react_1.default.createElement(ModalHeader, { p: 3 }, title),
                        react_1.default.createElement(Inner, null, children),
                        react_1.default.createElement(Footer, null,
                            react_1.default.createElement(rebass_1.Flex, null, renderActions(actions, true)),
                            react_1.default.createElement(rebass_1.Flex, null, renderActions(actions, false))))))))));
}
exports.default = default_1;
const fadeIn = styled_components_1.keyframes `
  from {
    transform: translateY(100px);
    opacity: 0;
  }
`;
const fadeinAnimate = styled_components_1.css `
    ${fadeIn} .3s
`;
const ModalWrap = styled_components_1.default(rebass_1.Box) `
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    min-height: 120px;
    animation: ${fadeinAnimate};
    position: relative;
`;
const ModalHeader = styled_components_1.default(rebass_1.Box) `
    // border-bottom: 2px solid #f1f1f1;
    // text-transform: uppercase;
    font-size: 1.2rem;
    border-radius: 10px;
    font-weight: 700;
    box-shadow: 0 -2px #c3c3c3;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
`;
const Inner = styled_components_1.default.div({
// padding: 20,
});
const Footer = styled_components_1.default.div({
    // borderTop: "1px solid #eee",
    background: "#f1f1f1",
    borderRadius: '0 0 10px 10px',
    display: "flex",
    justifyContent: "space-between",
    padding: 10,
    ".button": {
        marginInlineEnd: 10,
        marginInlineStart: 10,
    },
});
const Backdrop = styled_components_1.default.div({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,.2)",
    zIndex: 1000,
});
const BackdropTransparent = styled_components_1.default(rebass_1.Box)({
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1001,
    overflow: "auto",
    display: "flex",
});
const CloseButton = styled_components_1.default.div `
    background: #eee;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 1002;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    position: absolute;
    right: 10px;
    top: 10px;
    :hover {
        background: #ddd;
    }
`;
//# sourceMappingURL=index.js.map